import { Button, Select, Tag } from 'antd';
import {
	CAMPAIGN_FILTER_TEST_ID,
	FILTER_SECTION_TEST_ID,
	TEAM_MEMBER_FILTER_TEST_ID,
} from '../constants';
import styles from '../inboxPageV2.module.less';
import useInboxV2 from '../useInboxV2';
import IncludeExcludeFilter from './includeExcludeFilter/includeExcludeFilter';

/**
 * Global filter section for InboxV2
 * TODO build out properly: https://cassia.atlassian.net/browse/COPILOT-7764
 */
export default function InboxPageV2FilterSection() {
	const {
		campaignOptions,
		activeFilter,
		onCampaignFilterChange,
		enableTeamMemberFilter,
		teamMemberOptions,
		tagOptions,
		onTeamMemberFilterChange,
		onTagFilterChange,
		onClearFilters,
	} = useInboxV2();

	return (
		<div className={styles.filterWrapper} data-testid={FILTER_SECTION_TEST_ID}>
			{enableTeamMemberFilter && (
				<Select
					className={styles.filterDropdown}
					optionFilterProp="label"
					data-testid={TEAM_MEMBER_FILTER_TEST_ID}
					mode="multiple"
					placeholder="Team member"
					onChange={onTeamMemberFilterChange}
					tokenSeparators={[',']}
					options={teamMemberOptions}
					value={activeFilter.teamMembers}
					tagRender={TagRenderer}
				/>
			)}
			<Select
				className={styles.filterDropdown}
				optionFilterProp="label"
				data-testid={CAMPAIGN_FILTER_TEST_ID}
				mode="multiple"
				placeholder="Campaign"
				onChange={onCampaignFilterChange}
				options={campaignOptions}
				value={activeFilter.campaigns}
				tagRender={TagRenderer}
			/>
			<IncludeExcludeFilter
				onChange={onTagFilterChange}
				selections={activeFilter.tags}
				options={tagOptions}
				placeholder="Tags"
				menuHeader="Apply a tag filter"
			/>
			<Button type="text" onClick={onClearFilters}>
				Clear Filters
			</Button>
		</div>
	);
}

type TagRendererProps = {
	label: React.ReactNode;
	onClose: () => void;
	value: { label: string };
};
/**
 * Custom tag renderer for antd Select, allowing for aligned styling between the different filter dropdown types
 * @param param0
 * @returns
 */
function TagRenderer({ label, onClose, value }: TagRendererProps) {
	return (
		<Tag
			className={[styles.filterTag, styles.included].join(' ')}
			key={value.label}
			closable
			onClose={onClose}
		>
			{label}
		</Tag>
	);
}
